import { render, staticRenderFns } from "./ConsultaPedido.vue?vue&type=template&id=01cf5156&"
import script from "./ConsultaPedido.vue?vue&type=script&lang=js&"
export * from "./ConsultaPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports